/**
 * Created by Shuhin on 05/16/20.
 */
import React from "react";
import TextField from "material-ui/TextField";
import { white } from "material-ui/styles/colors";
import RaisedButton from "material-ui/RaisedButton";
import { RadioButton, RadioButtonGroup } from "material-ui/RadioButton";
import ReactTooltip from "react-tooltip";
import gStyles from '../../utility/styles';

const styles = {
  root: {
    width: "70%",
    marginLeft: "15%",
  },
  fields: {
    height: "40px",
    width: "70%",
    marginLeft: "20px",
    marginRight: "10px",
  },
  mediumFields: {
    height: "30px",
    width: "50%",
    marginTop: "10px",
    display: "inline-block",
  },
  missionText: {
    height: "40px",
    fontSize: "15px",
    marginTop: "10px",
    marginLeft: "15px",
    display: "inline-block",
  },
  text: {
    height: "40px",
    fontSize: "15px",
    marginLeft: "15px",
    display: "inline-block",
  },
  notesText: {
    height: "10px",
    fontSize: "15px",
    marginLeft: "15px",
    display: "inline-block",
  },
  dueText: {
    height: "30px",
    fontSize: "15px",
    marginLeft: "15px",
    display: "inline-block",
  },
  mediumRadios: {
    marginLeft: "15px",
    display: "inline-block",
  },
  mediumText: {
    float: "left",
    marginTop: "12px",
    fontSize: "15px",
    marginLeft: "15px",
    display: "inline-block",
  },
  buttonGroup: {
    paddingTop: "30px",
    paddingBottom: "15px",
    marginLeft: "40%",
  },
  coordinates: {
    padding: "5px",
  },
  innerSection: {
    padding: "5px",
    margin: "5px",
    backgroundColor: "#F4F4F4",
  },
  leftSection: {
    display: "inline-block",
  },
  innerDiv: {
    margin: "8px",
    height: "25px",
  },
};

const UpdatePaymentForm = (props) => {
  let {
    amount,
    medium,
    fromPhone,
    notes,
    handleSelect,
    handleChange,
    toggleManualPaymentDialog,
    className,
    style,
    mission,
    handleSubmit,
  } = props;

  return (
    <div
      className={className || "manual_payment"}
      style={{ ...styles.root, ...style }}
    >
        <h1 style={gStyles.header}>Update Payment</h1>
        <div>
          <div style={styles.missionText}>
            <span>Mission Number: </span>
            <span>{mission.mission_number}</span>
          </div>
        </div>

        <div>
          <div style={styles.text}>
            <span>User: </span>
            <span>{mission.patient.user.name}</span>
          </div>
        </div>

        <div>
          <div style={styles.text}>
            <span>Patient: </span>
            <span>{mission.patient.name}</span>
          </div>
        </div>

        <div>
          <div style={styles.text}>
            <span>Bill Amount: </span>
            <span>{mission.bill_amount}</span>
          </div>
        </div>
        
        <div>
          <div style={styles.dueText}>
            <span>Due Amount: </span>
            <span>{mission.due_amount}</span>
          </div>
        </div>

        <form>
        <div>
          <div style={styles.text}>Amount: </div>
          <TextField
            name="amount"
            value={amount}
            type="number"
            required={true}
            underlineShow={true}
            onChange={handleChange.bind(null, "amount")}
          />
        </div>
        <div>
          <div style={styles.mediumText}>Medium: </div>
          <RadioButtonGroup
            name="medium"
            required={true}
            valueSelected={medium}
            style={styles.mediumRadios}
            onChange={handleSelect.bind(null, "medium")}
          >
            <RadioButton
              value="bkash"
              label="bKash"
              style={styles.mediumFields}
            />
            <RadioButton
              value="cash"
              label="Cash"
              style={styles.mediumFields}
            />
            <RadioButton
              value="other"
              label="Other"
              style={styles.mediumFields}
            />
          </RadioButtonGroup>
        </div>
        {medium === "bkash" && (
          <div>
            <ReactTooltip />
            <div style={styles.text}>From Phone: </div>
            <div
              data-tip="From which phone number bKash was sent"
              style={styles.text}
            >
              <TextField
                name="fromPhone"
                value={fromPhone}
                underlineShow={true}
                onChange={handleChange.bind(null, "fromPhone")}
              />
            </div>
          </div>
        )}
        <div>
          <div style={styles.notesText}>Notes: </div>
          <TextField
            name="notes"
            value={notes}
            underlineShow={true}
            onChange={handleChange.bind(null, "notes")}
          />
        </div>
        <div style={styles.buttonGroup}>
          <RaisedButton
            label="Cancel"
            labelColor={white}
            onTouchTap={toggleManualPaymentDialog}
            backgroundColor="#C54026"
          />
          &nbsp;
          <RaisedButton
            label="Save Changes"
            labelColor={white}
            style={styles.button}
            backgroundColor="#14A46E"
            onTouchTap={handleSubmit}
          />
        </div>
        </form>
    </div>
  );
};
export default UpdatePaymentForm;



// WEBPACK FOOTER //
// ./src/screens/pending-payments/manual-payment-form.component.js